// Customer-facing wording for chart evidence. Internal identifiers (chart ids, version numbers) stay admin-only.
export const fmtDate = (iso) => {
  const d = new Date(String(iso).slice(0, 10));
  return Number.isNaN(d.getTime()) ? String(iso).slice(0, 10) : d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric", timeZone: "UTC" });
};

// "Official Gap Kids size chart · US · checked September 11, 2026"
export const sourceLine = (e) => e ? `Official ${e.brand} size chart · ${e.locale || "US"}${e.verification_date ? ` · checked ${fmtDate(e.verification_date)}` : ""}` : "";

// "XXL (on hold (conflicting published values))" → plain language; other reasons pass through.
export const exclusionText = (x) => /hold|conflict/i.test(x.reason || "")
  ? `${x.size_label} is currently excluded while we resolve conflicting chart information`
  : `${x.size_label}: ${x.reason}`;
